/** EvolveRPG — overridden layout copy (fast-play, momentum-driven voice). */
export const layoutEvoEn = {
  'layout.nav.veil': 'The Lobby',
  'layout.nav.enter': 'Jump into {world}',
  'layout.footer.tagline': 'A 3D roleplaying game where every character starts at zero and grows through play.',
}
